import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    editProfile: false,
    loginModal: false,
    socialMediaData: null,
    homeSections: {
        banner: true,
        promotion: true,
        upcoming_event: false,
        nearby_venue: true
    },
    show_maintenance_notice: false,
    maintenance_message: 'We have scheduled maintenance to improve your experience.'
}

export const generalOperationSlice = createSlice({
    name: 'generalOperation',
    initialState,
    reducers: {
        setEditProfile(state, action) {
            state.editProfile = action.payload;
        },
        setLoginModal(state, action) {
            state.loginModal = action.payload;
        },
        socialMediaData(state, action) {
            state.socialMediaData = action.payload;
        },
        setHomeSections(state, action) {
            state.homeSections = action.payload;
        },
        setMaintenanceNotice(state, action) {
            state.show_maintenance_notice = action.payload.show_maintenance_notice;
            if (!action.payload.show_maintenance_notice ||
                !action.payload.maintenance_message ||
                action.payload.maintenance_message.trim() === '') {
                state.maintenance_message = initialState.maintenance_message;
            } else {
                state.maintenance_message = action.payload.maintenance_message;
            }
        }
    }
})

export const { setEditProfile, setLoginModal, socialMediaData, setHomeSections, setMaintenanceNotice } = generalOperationSlice.actions;
export default generalOperationSlice.reducer